import React, { useState, useEffect, Dispatch } from 'react'
import { useDispatch } from 'react-redux'
import { makeStyles, Theme, createStyles, Paper, Grid, TextField, FormControlLabel, Checkbox, Snackbar, Link, Dialog, DialogTitle, Box, Typography } from '@material-ui/core';
import Button from 'reactstrap/lib/Button';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import clsx from 'clsx'
import { useForm, SubmitHandler } from "react-hook-form";
import moment from 'moment'
import SearchService from '../../services/search.service';
import { FormValues } from '../../store/models/employeeData.model';
import { getEmployeeData, getSearchReports } from '../../store/actions';
import { useHistory } from 'react-router';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { SystemValues } from '../../store/models/systemValues.model';
import LogoComponent from './logo.component';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
        margin: {
            margin: theme.spacing(2),
        },
        padding: {
            padding: theme.spacing(2),
            width: 650
        },
        bulletArea: {
            background: ''
        },
        errorBox: {
            backgroundColor: '#FAE6E6'
        },
        terms: {
            padding: theme.spacing(2),
            font: 'Arial, Arial Bold',
            fontSize: '1em',
            whiteSpace: 'pre-wrap'
        },
        link: {
            textDecoration: 'underline'
        }
    }),
);

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const SearchComponent: React.FC = () => {
    const classes = useStyles()
    const dispatch: Dispatch<any> = useDispatch()
    const history = useHistory()
    const [selectedDate, setSelectedDate] = useState<Date | null>(
        new Date('1990-08-18T21:11:54'),
    );
    const { register, handleSubmit } = useForm<FormValues>();
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [systemValues, setSystemValues] = useState<SystemValues>();

    useEffect(() => {
        SearchService.getSystemValues().then(result => {
            setSystemValues(result)
            sessionStorage.setItem("SystemValues", JSON.stringify(result))
        }).catch((ex: any) => { console.log(ex.message) })
    }, [])

    const handleDateChange = (date: Date | null) => {
        setSelectedDate(date);
    };

    const onSubmit: SubmitHandler<FormValues> = (data) => {
        data.birthday = moment(selectedDate).format("DD/MM/yyyy")
        dispatch(getEmployeeData(data))

        SearchService.getISearchServiceCollection(data).then(result => {
            if (result.tasks.length > 0) {
                dispatch(getSearchReports(result))
                if (data.logonID === "") data.logonID = String(result.personID)
                history.push('/result')
            }
            else {
                setOpen(true)
            }
        }).catch((ex: any) => { console.log(ex.message) })
    }

    const TermsConditionsPopup = () => {
        setOpenDialog(true)
    }
    return (
        <div>
            <LogoComponent />
            <p>The details you provide below must match the details of the person when they first registered.</p>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Paper className={clsx(classes.padding)} elevation={6}>
                    <div className={classes.margin}>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item md={true} sm={true} xs={true}>
                                <TextField name="firstName" label="First Name" type="text" fullWidth autoFocus required inputProps={{ ...register('firstName') }} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item md={true} sm={true} xs={true}>
                                <TextField name="lastName" label="Last Name" type="text" fullWidth required inputProps={{ ...register('lastName') }} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item md={true} sm={true} xs={true}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        required={true}
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="birthday"
                                        name="birthday"
                                        label="Date of birth"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        inputProps={{ ...register('birthday') }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                        <br />
                        {systemValues?.isEmailPhone && (
                            <h5>And one of:</h5>)}
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item md={true} sm={true} xs={true}>
                                <TextField name="logonID" label="Logon ID" type="text" fullWidth inputProps={{ ...register('logonID') }} />
                            </Grid>
                        </Grid>
                        {systemValues?.isEmailPhone && (
                            <>
                                <Grid container spacing={8} alignItems="flex-end">
                                    <Grid item md={true} sm={true} xs={true}>
                                        <TextField name="phone" label="Phone Number" type="text" fullWidth inputProps={{ ...register('phone') }} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={8} alignItems="flex-end">
                                    <Grid item md={true} sm={true} xs={true}>
                                        <TextField name="email" label="Email" type="email" fullWidth inputProps={{ ...register('email') }} />
                                    </Grid>
                                </Grid>
                            </>)}
                        <Grid container alignItems="center" justify="space-between">
                            <Grid item>
                                <FormControlLabel control={
                                    <Checkbox
                                        color="primary"
                                        required
                                    />
                                } label={<div>
                                    <span>I agree with the </span>
                                    <Link color="textPrimary" onClick={TermsConditionsPopup} style={{ textDecoration: 'underline' }}>Terms and Conditions</Link>
                                </div>} />

                            </Grid>

                        </Grid>
                        <Grid container justify="flex-start" style={{ marginTop: '10px' }}>
                            <Button type="submit" variant="outlined" color="primary" style={{ textTransform: "none" }}>Check details</Button>
                        </Grid>
                    </div>
                </Paper>
            </form>
            <div className={classes.root}>
                <Snackbar open={open} autoHideDuration={4000} onClose={() => setOpen(false)}>
                    <Alert onClose={() => setOpen(false)} severity="error">
                        {systemValues && systemValues.portalNotFoundMsg}
                    </Alert>
                </Snackbar>
            </div>
            <Dialog onClose={() => setOpenDialog(false)} aria-labelledby="simple-dialog-title" open={openDialog}>
                <DialogTitle>Terms and Conditions</DialogTitle>
                <Box>
                    <Typography className={classes.terms}>
                        {systemValues && systemValues.termsPortal}
                    </Typography>
                </Box>
            </Dialog>
        </div >
    )
}

export default SearchComponent